import React from 'react'
import { get, set, unset, includes } from 'lodash'

import TextField from 'material-ui/TextField'
import FlatButton from 'material-ui/FlatButton'
import { Card, CardActions, CardHeader } from 'material-ui/Card'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import FileInput from '../file-input'
import Wysiwyg from '../wysiwyg'
import AutoCompleteField from '../AutoCompleteField'
import TagSelector from '../institutions/tag-selector'

const styles = {
  currentImage: {
    maxWidth: '300px',
    display: 'block'
  },
  repeater: {
    marginLeft: '15px'
  },
  repeaterTitle: {
    marginLeft: '-15px'
  },
  repeaterCard: {
    margin: '15px'
  },
  repeaterFields: {
    margin: '15px'
  },
  repeaterAdd: {
    margin: '15px'
  }
}

class Fields extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      content: props.content,
      files: props.files
    }
  }

  componentWillReceiveProps (nextProps) {
    const update = { }

    if (nextProps.content) {
// @ts-ignore
      update.content = nextProps.content
    }

    if (nextProps.files) {
// @ts-ignore
      update.files = nextProps.files
    }

    if (Object.keys(update).length) {
      this.setState(update)
    }
  }

  render () {
    const { content, files } = this.state
    const { fields, schema } = this.props

    return (
      <div>
        {fields.map((field, i) => {
          const label = schema && includes(schema.required, field.prop)
            ? `${field.name} *`
            : field.name

          if (field.type === 'text' || field.type === 'number') {
            return (
              <TextField
                type={field.type}
                value={content[field.prop] || ''}
                key={field.prop}
                floatingLabelText={label}
                onChange={this.handleTextChange.bind(this, field)}
                fullWidth
                multiLine={field.type === 'text'}
              />
            )
          } else if (field.type === 'autocomplete') {
            return (
              <AutoCompleteField
                key={field.prop}
                field={field}
                value={content[field.prop]}
                onChange={this.handleAutocompleteChange.bind(this, field)}
              />
            )
          } else if (field.type === 'chipinput') {
            return (
              <TagSelector
                key={field.prop}
                label={label}
                value={content[field.prop] || []}
                onChange={this.handleChipInputChange.bind(this, field)}
              />
            )
          } else if (field.type === 'richtext') {
            return (
              <Wysiwyg
                theme='snow'
                label={label}
                key={field.name}
                value={content[field.prop] || ''}
                onChange={this.handleWysiwygChange.bind(this, field)}
              />
            )
          } else if (field.type === 'image') {
            const imageUrl = content[field.prop]
            const newFilename = files[field.prop] && files[field.prop].file.name

            return (
              <div key={field.prop} style={{ marginTop: '1em', marginBottom: '1em' }}>
                <FileInput
                  accept='image/*'
                  label={`Upload ${label}`}
                  onFileSelected={this.handleFileSelection.bind(this, field)}
                />

                {imageUrl && <p>
                  Current Image: <img src={imageUrl} style={styles.currentImage} />
                </p>}

                {newFilename && <p>New Image: {newFilename}</p>}
              </div>
            )
          } else if (field.type === 'select') {
            return (
              <SelectField
                key={field.prop}
                floatingLabelText={label}
                value={content[field.prop] || null}
                onChange={this.handleSelectChange.bind(this, field)}
              >
                {field.options.map((option, i) => (
                  <MenuItem
                    key={option.value + i}
                    value={option.value}
                    primaryText={option.name}
                  />
                ))}
              </SelectField>
            )
          } else if (field.type === 'repeater') {
            const repeaterItems = content[field.prop] || []
            const repeaterSchema = get(schema, ['properties', field.prop], { items: {} })

            return (
              <div key={field.prop}>
                <CardHeader title={field.name} style={styles.repeaterTitle} />

                <div style={styles.repeater}>
                  {repeaterItems.map((repeaterItem, index) => {
                    const repeaterFiles = get(files, [field.prop, index], {})

                    return (
                      <Card key={`${i}-repeater-${index}`} style={styles.repeaterCard}>
                        <div style={styles.repeaterFields}>
                          <Fields
                            fields={field.fields}
                            content={repeaterItem}
                            files={repeaterFiles}
                            schema={repeaterSchema.items}
                            handleValueChange={this.handleRepeaterFieldValueChange.bind(this, field, index)}
                            handleFileChange={this.handleRepeaterFieldFileSelection.bind(this, field, index)}
                          />
                        </div>

                        <CardActions>
                          <FlatButton
                            label='Move Up'
                            disabled={index === 0}
                            onClick={this.handleRepeaterFieldMove.bind(this, field, index, -1)}
                          />
                          <FlatButton
                            label='Move Down'
                            disabled={index === repeaterItems.length - 1}
                            onClick={this.handleRepeaterFieldMove.bind(this, field, index, 1)}
                          />
                          <FlatButton
                            secondary
                            label='Remove'
                            onClick={this.handleRepeaterFieldRemove.bind(this, field, index)}
                          />
                        </CardActions>
                      </Card>
                    )
                  })}
                </div>

                {(!repeaterSchema.maxItems || repeaterItems.length < repeaterSchema.maxItems) && (
                  <div style={styles.repeaterAdd}>
                    <FlatButton
                      primary
                      label='Add'
                      onClick={this.handleRepeaterFieldAdd.bind(this, field)}
                    />
                  </div>
                )}
              </div>
            )
          } else {
            return <div key={field.prop} />
          }
        })}
      </div>
    )
  }

  handleTextChange (field, event) {
    this.props.handleValueChange(field, event.target.value)
  }

  handleWysiwygChange (field, value) {
    if (value === '<p><br></p>') {
      value = null
    }

    this.props.handleValueChange(field, value)
  }

  handleSelectChange (field, event, index, value) {
    this.props.handleValueChange(field, value)
  }

  handleAutocompleteChange (field, value) {
    this.props.handleValueChange(field, value)
  }

  handleChipInputChange (field, event, value) {
    this.props.handleValueChange(field, value)
  }

  handleFileSelection (field, file) {
    const formData = new window.FormData()
    formData.append('file', file, file.name)
    this.props.handleFileChange(field.prop, formData, file)
  }

  handleRepeaterFieldAdd (field) {
    const existingRepeaterFields = this.state.content[field.prop] || []
    this.props.handleValueChange(field, existingRepeaterFields.concat({}))
  }

  handleRepeaterFieldMove (field, index, offset) {
    const items = (this.state.content[field.prop] || []).slice()
    const target = index + offset
    if (target < 0 || target >= items.length) return
    ;[items[index], items[target]] = [items[target], items[index]]
    this.props.handleValueChange(field, items)
  }

  handleRepeaterFieldRemove (field, index) {
    const existingRepeaterFields = this.state.content[field.prop]
    existingRepeaterFields.splice(index, 1)
    this.props.handleValueChange(field, existingRepeaterFields)
  }

  handleRepeaterFieldValueChange (field, index, repeaterField, value) {
    const fieldContent = (this.state.content[field.prop] || []).slice()

    if (value === null || value === undefined) {
      unset(fieldContent, [index, repeaterField.prop])
    } else {
      set(fieldContent, [index, repeaterField.prop], value)
    }

    this.props.handleValueChange(field, fieldContent)
  }

  handleRepeaterFieldFileSelection (field, index, repeaterField, form, file) {
    const propPath = `${field.prop}[${index}].${repeaterField}`
    const formData = new window.FormData()
    formData.append('file', file, file.name)
    this.props.handleFileChange(propPath, formData, file, repeaterField)
  }
}

// @ts-ignore
Fields.propTypes = {
  handleValueChange: React.PropTypes.func.isRequired,
  handleFileChange: React.PropTypes.func.isRequired,
  fields: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  content: React.PropTypes.object.isRequired,
  schema: React.PropTypes.object,
  files: React.PropTypes.object.isRequired
}

// @ts-ignore
Fields.defaultProps = {
  content: {},
  files: {}
}

export default Fields
